import React, { useState, createContext, useCallback, useEffect } from "react";

import { PContext, AlertState } from "./types";

const initialState: AlertState = {
    message: "",
    type: "",
    show: false,
};

export const AlertContext = createContext({} as PContext);

export const AlertProvider = ({ children }: { children: any }) => {
    const [alertState, setAlertState] = useState<AlertState>(initialState);

    const resetAlertState = useCallback(() => {
        setAlertState(initialState);
    }, []);

    const updateAlertState = useCallback((args: Partial<AlertState>) => {
        setAlertState((prevState) => ({ ...prevState, ...args }));
    }, []);

    useEffect(() => {
        if (alertState.message) {
            setTimeout(() => {
                updateAlertState({ message: "", show: false });
            }, 5000);
        }
        return () => {};
    }, [alertState, updateAlertState]);

    return (
        <AlertContext.Provider
            value={{
                alertState,
                resetAlertState,
                updateAlertState,
            }}
        >
            {children}
        </AlertContext.Provider>
    );
};
